<template>
  <ag-modal-container
    :title="$t('company.title.restoreCompany')"
    width="900px"
    @close="back"
  >
    <div
      v-if="!loadingData && !companyList.length"
      class="text-center title mt-5"
      v-text="$t('company.noRemovedCompany')"
    />

    <company-list
      v-else
      :value="companyList"
      :selected.sync="selectedCompanyIdList"
      :loading="loadingData"
      light
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :disabled="loading"
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            :disabled="!selectedCompanyList.length || loading"
            color="error"
            class="ml-5"
            v-bind="attrs"
            v-on="on"
            v-text="$t('general.remove')"
          />
        </template>
      </ag-confirm-dialog>

      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="restoreMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.restore')"
        validation-btn-color="accent"
        @confirm="restoreSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRestore"
            :disabled="!selectedCompanyList.length || loading"
            color="accent"
            class="ml-5"
            v-bind="attrs"
            v-on="on"
            v-text="$t('general.restore')"
          />
        </template>
      </ag-confirm-dialog>
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import CompanyList from '../components/CompanyList'

export default {
  name: 'CompanyRestoreContainer',
  components: {
    AgModalContainer,
    AgConfirmDialog,
    CompanyList,
  },
  data () {
    return {
      companyList: [],
      selectedCompanyIdList: [],
      loadingData: false,
      loadingRemove: false,
      loadingRestore: false,
    }
  },
  computed: {
    loading () {
      return this.loadingRemove || this.loadingRestore
    },
    removeMessage () {
      const count = this.selectedCompanyIdList.length
      return this.$tc('company.realRemove.confirm', count, { count })
    },
    restoreMessage () {
      const count = this.selectedCompanyIdList.length
      return this.$tc('company.restore.confirm', count, { count })
    },
    selectedCompanyList () {
      return this.selectedCompanyIdList.map(id => this.companyList.find(item => item.id === id))
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'CompanyRestore') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async fetchData () {
      this.loadingData = true
      this.companyList = await Repositories.company.getList({ onlyDeleted: true })
      this.loadingData = false
    },
    async removeSelected () {
      try {
        this.loadingRemove = true
        const count = this.selectedCompanyIdList.length
        await Repositories.company.delete(this.selectedCompanyIdList, { permanentDeletion: true })

        this.selectedCompanyIdList = []
        this.fetchData()

        const notification = this.$tc('company.realRemove.success', count, { count })
        this.showSuccessNotification(notification)
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loadingRemove = false
      }
    },
    async restoreSelected () {
      try {
        this.loadingRestore = true
        const count = this.selectedCompanyIdList.length
        await Repositories.company.restore(this.selectedCompanyIdList)

        this.selectedCompanyIdList = []
        this.fetchData()

        const notification = this.$tc('company.restore.success', count, { count })
        this.showSuccessNotification(notification)
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loadingRestore = false
      }
    },
  },
}
</script>
